import React from 'react';
import {
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent
} from '@mui/material';
import PropTypes from 'prop-types';
import { trakrefFontFamilySemiBold } from '../../utils';
import { Grey2, Grey4, Black } from '../../color_utils';
import CloseIcon from '@mui/icons-material/Close';

const CommonModal = ({
    children,
    open,
    close,
    header,
    icon,
    iconClicked,
    bottom,
    scroll,
    renderCloseIcon,
    headerTopMargin,
    headerFontWeight,
    headerWidth,
    maxWidth,
    width,
    paperSx,
}) => {
    const closeButton = { position: 'absolute', right: 8, top: 8, zIndex: 2, color: Grey2, };
    const closeIconSpacing = renderCloseIcon ? '56px' : 0;
    const popHeader = {
        textAlign: 'center',
        marginTop: `${headerTopMargin}%`,
        fontWeight: headerFontWeight,
        position: 'relative',
        fontFamily: trakrefFontFamilySemiBold,
        color: Black,
        fontSize: '22px',
        width: headerWidth,
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingLeft: closeIconSpacing,
        paddingRight: closeIconSpacing,
        boxSizing: 'border-box',
    };
    const headerText = {
        display: 'block',
        width: '100%',
        whiteSpace: 'normal',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        lineHeight: 1.3,
    };

    return (
        <Dialog
            open={open}
            onClose={close}
            scroll={scroll}
            aria-labelledby="trakref popup"
            aria-describedby="trakref popup"
            PaperProps={{ sx: { maxWidth: maxWidth, width: width, ...paperSx } }}
            sx={{
                '&.MuiDialog-root': { bottom: `${bottom}vh` }
            }}
        >
            {renderCloseIcon && (
                <div style={{ backgroundColor: Grey4, width: '48px', height: '48px', position: 'absolute', right: 0, top: 0, zIndex: 1 }}>
                    <IconButton aria-label="close" onClick={close} style={closeButton} >
                        <CloseIcon style={{ color: Grey2, fontSize: "22px", stroke: Grey2, strokeWidth: 1 }} />
                    </IconButton>
                </div>
            )}
            {
                header && (
                    <DialogTitle style={popHeader}>
                        {icon && (
                            <div onClick={iconClicked} className="ProposalModalHeaderIcon">
                                {icon}
                            </div>
                        )}
                        <span style={headerText}>{header}</span>
                    </DialogTitle>
                )
            }
            <DialogContent sx={{ px: { xs: 0, sm: 3 }, py: { xs: 0, sm: 2.5 } }}>
                {children}
            </DialogContent>
        </Dialog>
    );
};

CommonModal.propTypes = {
  children: PropTypes.node.isRequired,
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  header: PropTypes.string,
  bottom: PropTypes.number,
  scroll: PropTypes.string,
  renderCloseIcon: PropTypes.bool,
  headerTopMargin: PropTypes.number,
  headerFontWeight: PropTypes.number,
};

CommonModal.defaultProps = {
    disableEnforceFocus: false,
    header: "",
    bottom: 0,
    scroll: "body",
    renderCloseIcon: true,
    headerTopMargin: 2,
    headerFontWeight: 600,
    headerWidth: "100%",
    maxWidth: "600px",
};

export default CommonModal;
